export enum RadarColumnKeys {
  DataSource = 'dataSource',
  Employees = 'employees',
  Usage = 'usage',
  Category = 'category',
  DiscoveryDate = 'discoveryDate',
  FeedbackStatus = 'feedbackStatus',
  DataSourceOrigin = 'dataSourceOrigin',
  LastLogin = 'lastLogin'
}